export default __webpack_public_path__ + "static/media/Swiss721BTRegular.4112b9b5.woff2";